import Vue from 'vue';
import VueRouter from 'vue-router';
import LayoutAuth from '@/layouts/layout-auth.vue';
import LayoutHome from '@/layouts/layout-home.vue';
import security from './security';
import { routes as docs, loadMiddlewares } from '@/plugins/xtpgui';
import sample from '@/domains/sample/routes';
import auth from '@/router/middleware/auth'
import store from '@/store';

import tesourariaRoutes from './modules/tesouraria.js';
import elementosComunsRoutes from './modules/elementosComuns.js';
import operacoesFinanceirasRoutes from './modules/operacoesFinanceiras.js';
//import domains from '@/domains/routes';

Vue.use(VueRouter);


const routes = [
    {
      path: '/',
      component: LayoutAuth,
      children: [
        {
          path: '',
          name: 'login',
          component: () => import(/* webpackChunkName: "login" */ '@/views/authentication/login.vue'),
          meta: {
            middleware: [],
            allowAnonymous: true
          }
        },
        {
          path: 'logout',
          name: 'logout',
          component: () => import(/* webpackChunkName: "logout" */ '@/views/authentication/logout.vue'),
          meta: {
            middleware: [],
            allowAnonymous: true
          }
        },
      ]
    },
    {
      path: '/',
      component: LayoutHome,
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import(/* webpackChunkName: "inicio" */ '@/views/home/home.vue'),
          meta: {
            middleware: [],
          }
        },

        ...tesourariaRoutes,
        ...elementosComunsRoutes,
        ...operacoesFinanceirasRoutes,

        
        // Rotas não agrupadas / módulos de teste

        {
          path: 'AI-Treasury',
          name: 'AI-Treasury',
          component: () => import(/* webpackChunkName: "AI-Treasury" */ '@/views/modules/AI-Treasury/index.vue'),
          meta: {
            middleware: [],
            title: 'AI-Treasury',
            tab: true,
          },
        },
       
        // {
        //   path: 'home/reports',
        //   name: 'home_reports',
        //   component: () => import(/* webpackChunkName: "financial" */ '@/views/modules/reports.vue'),
        //   meta: {
        //     middleware: [],
        //     title: 'Relatórios',
        //     tab: true,
        //   },
        // },
        // {
        //   path: 'home/entradaCaptacoes',
        //   name: 'home_entradaCaptacoes',
        //   component: () => import(/* webpackChunkName: "entradaMovimentos" */ '@/views/modules/operacoesFinanceiras/captacoes/EntradaDeCaptacoes'),
        //   meta: {
        //     middleware: [],
        //     title:  ('modules.entradaDeCaptacoes.label'),
        //     tab: true,
        //   },
        // },
        // {
        //   path: 'home/captacoesEmAberto',
        //   name: 'home_captacoesEmAberto',
        //   component: () => import(/* webpackChunkName: "entradaMovimentos" */ '@/views/modules/operacoesFinanceiras/captacoes/CaptacoesEmAberto'),
        //   meta: {
        //     middleware: [],
        //     title:  ('modules.captacoesEmAberto.label'),
        //     tab: true,
        //   },
        // },
        // {
        //   path: 'home/captacoesEfetivadas',
        //   name: 'home_captacoesEfetivadas',
        //   component: () => import(/* webpackChunkName: "entradaMovimentos" */ '@/views/modules/operacoesFinanceiras/captacoes/CaptacoesEfetivadas'),
        //   meta: {
        //     middleware: [],
        //     title:  ('modules.captacoesEfetivadas.label'),
        //     tab: true,
        //   },
        // },
      ]
    },
    ...docs,
    ...sample,
  ]
  
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })
  
  // Restaurar estado de autenticação quando a aplicação recarrega
  let authRestored = false;
  router.beforeEach(async (to, from, next) => {
    if (!authRestored) {
      await store.dispatch('auth/restoreAuthState');
      authRestored = true;
    }
    return security(to, from, next);
  })
  
  router.beforeResolve(async (to, from, next) => {
    return loadMiddlewares(to, from, next, router, store);
  });
  export default router